import Container from './TFAReminderPage.container';
import Component from './TFAReminderPage';
export default Container(Component);
